import React from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import { headerConstants, IMG_URIS as ImgURIs } from 'appConstants';
import PropTypes from 'prop-types';
import { useFlags } from 'launchdarkly-react-client-sdk';

/* eslint-disable react/prop-types */
const GoBack = ({ history }) => {
	if (history.location.pathname === '/') return null;
	return (
		// eslint-disable-next-line react/jsx-handler-names
		<Button className="icon-back" onClick={history.goBack}>
			<ArrowBackIcon
				style={{
					fontSize: 20,
					color: '#000000'
				}}
			/>
		</Button>
	);
};
/* eslint-enable react/prop-types */

// eslint-disable-next-line react/no-multi-comp
const Header = ({ history }) => {
	const { iCimsBrandRefreshTextEngagement: iCIMSBrandRefresh } = useFlags();
	const icimsLogoUrl = iCIMSBrandRefresh ? ImgURIs.ICIMS_LOGO_NEW : ImgURIs.ICIMS_LOGO;
	const icimsLogoHeight = iCIMSBrandRefresh ? headerConstants.LOGO_HEIGHT : headerConstants.LOGO_HEIGHT_OLD;

	return (
		<header>
			<div className="trx-header">
				<img
					alt="Brand"
					style={{ height: icimsLogoHeight, marginLeft: '1.1rem' }}
					src={icimsLogoUrl}
				/>
				<GoBack history={history} />
			</div>
		</header>
	);
};

Header.propTypes = {
	history: PropTypes.object
};

export default withRouter(Header);
